import { apiGet, apiPost } from 'utils/http';

export type SessionClient = {
  id: string;
  name: string;
  roles: string[];
  email: string | null;
  merchantSites: string[];
};

export type BankIdStatus =
  | 'PENDING'
  | 'COMPLETED'
  | 'CONSUMED'
  | 'FAILED'
  | 'TIMED_OUT'
  | 'USER_CANCELLED'
  | 'USER_SIGNING';

export type BankIdClient = {
  id: string;
  name: string;
  merchantId: string;
};

export type BankIdAuthenticationResponse = {
  qrData: string;
  reference: string;
};

export type BankIdLoginParams = {
  clientId: string | null;
  bankIdReference: string;
};

export type BankIdStatusResponse = {
  status: BankIdStatus;
  qrData: string;
};

export type BankIdLoginResponse = {
  clients: BankIdClient[];
  session: SessionResponse | null;
};

export type CredentialsLoginParams = {
  clientId: string;
  clientSecret: string;
};

export type SessionResponse = {
  client: SessionClient;
  expires: string | null;
};

const sessionAPI = {
  startBankIdAuthentication: async (): Promise<BankIdAuthenticationResponse> => {
    return apiPost('/session/bankid/authenticate', {
      body: {},
    }) as Promise<BankIdAuthenticationResponse>;
  },
  getBankIdStatus: async (bankIdReference: string): Promise<BankIdStatusResponse> => {
    return apiGet('/session/bankid/status', {
      query: {
        bankIdReference,
      },
    }) as Promise<BankIdStatusResponse>;
  },
  loginBankId: async ({ clientId, bankIdReference }: BankIdLoginParams): Promise<BankIdLoginResponse> => {
    return apiPost('/session/bankid/login', {
      query: {
        bankIdReference,
        clientId,
      },
    }) as Promise<BankIdLoginResponse>;
  },
  loginCredentials: async ({ clientId, clientSecret }: CredentialsLoginParams): Promise<SessionResponse> => {
    return apiPost('/session/credentials/login', {
      body: {
        id: clientId,
        secret: clientSecret,
      },
    }) as Promise<SessionResponse>;
  },
  getCurrent: async (): Promise<SessionResponse> => {
    return apiGet('/session/current') as Promise<SessionResponse>;
  },
  refresh: async (): Promise<unknown> => {
    return apiPost('/session/refresh');
  },
  logout: async (): Promise<unknown> => {
    return apiPost('/session/logout');
  },
};

export { sessionAPI };
